// src/utils/currencyHelper.js

import Apiurl from "./apiUrl";

export const CURRENCY_SYMBOLS = {
  INR: '₹',
  AUD: 'A$',
  BRL: 'R$',
  CAD: 'CA$',
  CHF: 'CHF',
  CNY: '¥',
  CZK: 'Kč',
  DKK: 'kr',
  EUR: '€',
  GBP: '£',
  HKD: 'HK$',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  ISK: 'kr',
  JPY: '¥',
  KRW: '₩',
  MXN: 'Mex$',
  MYR: 'RM',
  NOK: 'kr',
  NZD: 'NZ$',
  PHP: '₱',
  PLN: 'zł',
  RON: 'lei',
  SEK: 'kr',
  SGD: 'S$',
  THB: '฿',
  TRY: '₺',
  USD: '$',
  ZAR: 'R'
};

// Fallback rates including your provided dataset
let cachedRates = {
  INR: 1.0,
  AUD: 0.014933,
  BRL: 0.055945,
  CAD: 0.014751,
  CHF: 0.0087228,
  CNY: 0.070009,
  CZK: 0.22986,
  DKK: 0.070504,
  EUR: 0.0094331,
  GBP: 0.0079035,
  HKD: 0.082388,
  HUF: 3.4608,
  IDR: 190.89,
  ILS: 0.032828,
  ISK: 1.281,
  JPY: 1.6589,
  KRW: 14.0774,
  MXN: 0.19566,
  MYR: 0.042816,
  NOK: 0.097609,
  NZD: 0.018709,
  PHP: 0.67201,
  PLN: 0.041548,
  RON: 0.050474,
  SEK: 0.10429,
  SGD: 0.013465,
  THB: 0.3547,
  TRY: 0.52339,
  USD: 0.010502,
  ZAR: 0.17483
};

// Fetch live rates from a free public API (Frankfurter base INR)


export const fetchLiveExchangeRates = async () => {
  try {
    const token = localStorage.getItem('u_token');

    const response = await fetch(`${Apiurl}admin/currency/list`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    const apiResponse = await response.json();

    // Convert API data array into currency rates object
    if (apiResponse?.status && Array.isArray(apiResponse.data)) {

      const rates = apiResponse.data
        .filter(currency => currency.is_active)
        .reduce((acc, currency) => {
          acc[currency.code] = Number(currency.exchange_rate);
          return acc;
        }, {});

      cachedRates = {
        INR: 1.0,
        ...rates
      };

      // Save converted rates in localStorage
      localStorage.setItem(
        'cached_exchange_rates',
        JSON.stringify(cachedRates)
      );

      console.log('Updated currency rates:', cachedRates);
    } else {
      throw new Error('Invalid currency API response');
    }

  } catch (error) {
    console.error('Failed to fetch live exchange rates:', error);

    const savedRates = localStorage.getItem('cached_exchange_rates');

    if (savedRates) {
      try {
        cachedRates = JSON.parse(savedRates);
      } catch (e) {
        console.error('Failed to parse cached exchange rates:', e);
      }
    }
  }
};



export const getSelectedCurrency = () => {
  const userDataRaw = localStorage.getItem('userData');
  if (userDataRaw) {
    try {
      const userData = JSON.parse(userDataRaw);
      if (userData?.currency) return userData.currency;
    } catch (e) {}
  }
  return localStorage.getItem('quotation_currency') || 'INR';
};

// Added getCurrencySymbol export to fix the compilation error
export const getCurrencySymbol = (currCode) => {
  const code = currCode || getSelectedCurrency();
  return CURRENCY_SYMBOLS[code] || code;
};

export const convertAmount = (amountInINR) => {
  const currency = getSelectedCurrency();
  const rate = cachedRates[currency] || 1;
  return Number(amountInINR || 0) * rate;
};

export const formatCurrency = (amountInINR) => {
  const currency = getSelectedCurrency();
  const converted = convertAmount(amountInINR);
  const symbol = CURRENCY_SYMBOLS[currency] || currency;

  return `${symbol} ${converted.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatAmount = (amountInINR) => {
  const converted = convertAmount(parseFloat(amountInINR));

  return converted?.toFixed(2);
};